import { useApp, type RuleUpdate } from "../state";

function fmtOffset(hours: number): string {
  if (hours >= 1 && Number.isInteger(hours)) return `${hours} hour${hours === 1 ? "" : "s"}`;
  if (hours < 1) {
    const minutes = Math.round(hours * 60);
    return `${minutes} minute${minutes === 1 ? "" : "s"}`;
  }
  return `${hours} hours`;
}

export function RulesContent({ update }: { update?: RuleUpdate }) {
  const { state } = useApp();
  const offset = fmtOffset(state.config.lock_offset_hours);
  const rounds = ["R32", "R16", "QF", "SF", "3P", "F"] as const;
  const missLimit = state.config.missing_pick_group_minimum_limit;
  const missFrom = state.config.missing_pick_limit_from_round;
  const missFromDate = state.config.missing_pick_limit_from_pt_date;
  const missStart = missFromDate
    ? new Date(`${missFromDate}T12:00:00Z`).toLocaleDateString([], {
        month: "short", day: "numeric", timeZone: "America/Los_Angeles",
      }) + " (PT)"
    : missFrom;

  return (
    <>
      <div className="rules-card__eyebrow">{update ? "RULES UPDATED" : "THE QUICK VERSION"}</div>
      <h2 id={update ? "rules-update-title" : "rules-title"}>{update?.title ?? "How to score points"}</h2>
      {update && <div className="rules-update-callout">{update.summary}</div>}
      <div className="rules-row rules-row--winner"><strong>+W</strong><span>Call the eventual winner — including penalties.</span></div>
      <div className="rules-row rules-row--exact"><strong>+E</strong><span>Nail the exact score before the shootout.</span></div>
      <div className="rules-total"><strong>Round ramp</strong><span>Later rounds count for more. Each match's max is winner + exact.</span></div>
      <table className="rules-ramp">
        <thead><tr><th>Round</th><th>Winner</th><th>Exact</th><th>Max</th></tr></thead>
        <tbody>
          {rounds.map((round) => {
            const scoring = state.config.scoring_by_round?.[round] ?? state.config.scoring;
            return (
              <tr key={round}>
                <td>{round === "3P" ? "3rd" : round}</td><td>{scoring.winner}</td><td>{scoring.exact}</td>
                <td>{scoring.winner + scoring.exact}</td>
              </tr>
            );
          })}
        </tbody>
      </table>
      <p>
        <strong>Missed a pick?</strong>{" "}
        {missLimit !== undefined && missStart
          ? `Starting ${missStart}, your first ${missLimit} misses receive the group's lowest score. Earlier misses do not use a safety net; later misses score 0.`
          : "You receive the lowest points earned by anyone who submitted for that match."}
        {" "}Every miss counts against you in tiebreaks.
      </p>
      <p><strong>Tied on points?</strong> We compare exact scores, correct goal differences, fewer missed eligible picks, then lowest total score error. If all are equal, the rank is shared.</p>
      <p>Each day's prediction booth opens <strong>{offset} after the previous day's last kickoff</strong>. Every match then locks independently <strong>{offset} before its own kickoff</strong>. That match's picks are revealed as soon as it locks.</p>
    </>
  );
}
